<template>
<div id="AdminList" class="list-container">
    <div class="title-container">
        <div class="search-area">
            <div class="search-item">
                <div class="key">{{$t(/*用户名*/'user.username')}}：</div>
                <div class="value">
                    <el-input v-model="searchForm.username" :placeholder="$t(/*请输入*/'c.input')" @keydown.native.enter='pageChange(1)'/>
                </div>
            </div>
            <div class="search-btn">
                <el-button type="primary" @click="pageChange(1)">{{$t(/*搜索*/'c.search')}}</el-button>
            </div>
        </div>
        <div class="btn-area">
            <EditAdmin btnType='primary' :btnText="$t(/*新增*/'c.add')+$t(/*管理员*/'user.admin')" @change='getTableData' v-if="$auth('ADMIN')"/>
        </div>
    </div>
    <div class="table-container">
        <el-table :data="tableData" v-loading='loading'>
            <el-table-column width="80" label="ID" prop="id"/>
            <el-table-column min-width="200" :label="$t(/*用户名*/'user.username')">
                <template slot-scope="{row}">
                    <router-link target="_blank" class="router-link" :to="getRouterLink('detail', row)">
                        {{ row.username }}
                    </router-link>
                </template>
            </el-table-column>
            <el-table-column width="170" :label="$t(/*创建时间*/'c.create_time')" prop="create_time">
                <template slot-scope="{row}">{{$U.timeFormat(row.create_time)}}</template>
            </el-table-column>
            <el-table-column width="240" :label="$t(/*操作*/'c.operation')" fixed="right">
                <template slot-scope="{row}">
                    <router-link target="_blank" class="router-link" :to="getRouterLink('detail', row)">{{$t(/*详情*/'c.detail')}}</router-link>
                    <template v-if="row.id !== 1">
                        <div class="divide" />
                        <EditAdmin :detail="row" @change='getTableData'/>
                        <div class="divide" />
                        <EditPassword :detail="row" @change='getTableData'/>
                        <div class="divide" />
                        <el-button type="text danger" @click='handleDelete(row.id)'>{{$t(/*删除*/'c.delete')}}</el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="paging-container">
        <el-pagination
            class="text-right"
            @current-change="pageChange"
            :current-page="currPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
import Core from '../../core'

export default {
    name: "AdminList",
    components: {
        EditAdmin: () => import('./components/EditAdmin.vue'),
        EditPassword: () => import('./components/EditPassword.vue'),
    },
    data() {
        return {
            loading: false,

            currPage: 1,
            total: 0,
            pageSize: 10,

            searchForm: {
                username: '',
            },
            tableData: [],
        }
    },
    mounted() {
        this.pageChange(1);
    },

    methods: {
        getRouterLink(key, item = {}) {
            switch (key) {
                case 'detail':
                    return {
                        path: '/admin/detail',
                        query: {id: item.id}
                    }
            }
        },

        pageChange(val) {
            this.currPage = val;
            this.getTableData()
        },
        getTableData() {
            Core.Api.Admin.list({
                page: this.currPage,
                ...this.searchForm
            }).then(res => {
                console.log('getTableData res:', res)
                this.tableData = res.list;
                this.total = res.count
            })
        },

        handleDelete(id) {
            this.$confirm(
                this.$t(/*删除用户后，平台上该用户的所有数据将清除。*/'user.ask_delete_content'),
                this.$t(/*确定要删除该用户吗？*/'user.ask_delete_title'), {
                confirmButtonText: this.$t(/*确定*/'c.confirm'),
                cancelButtonText: this.$t(/*取消*/'c.cancel'),
                type: 'warning'
            }).then(() => {
                Core.Api.Admin.delete({id}).then(() => {
                    this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
                    this.getTableData()
                })
            })
        },
    },
}
</script>

<style scoped lang="scss">
// #AdminList {}
</style>